const ErrorTypes = {
    LESSON: 'LESSON',
    RESPONSE: 'RESPONSE',
    INTRO_VIDEO: 'INTRO_VIDEO',
};

export {ErrorTypes};
